<template>
  <div class="content blacklist">
    <el-form :model="form_obj" ref="ruleForm" label-width="200px">
    <div class="box">
      <div class="title">等级佣金比例</div>
      <el-form-item label="等级级别" prop="name">
        <div class="level-list">
          <div class="left-lst">
            <div class="left-lst-item" v-for="(item, idx) in levelList" :key="idx">
              <el-radio v-model="form_obj.now_level" v-if="idx < 5" :label="item.value" border size="small">{{item.name}}</el-radio>
            </div>
          </div>
          <div class="right-lst">          
            <div class="right-lst-item" v-for="(item, idx) in levelList" :key="idx">
              <el-radio v-model="form_obj.now_level" v-if="idx > 4" :label="item.value" border size="small">{{item.name}}</el-radio>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="等级名称" prop="name">
        <el-input v-model="other_obj.level_name" class="demoRuleForm" placeholder="请输入等级名称"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="油品" prop="oil_type">
        <el-table :data="commission" size="medium" :span-method="objectSpanMethod" style="width:900px" border>
          <el-table-column label="名称" prop="name" width="60px"></el-table-column>
          <el-table-column label="级别" prop="level" width="100px"></el-table-column>
          <el-table-column label="佣金比例(%)" width="200px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.balance" size="medium"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="积分比例(%)" width="200px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.point" size="medium"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="优惠券">
            <template slot-scope="scope">
              <el-button type="text" @click="selectCoupon(scope.row.coupon,scope.$index)">选择</el-button>
              <el-tag
                v-for="(tag,index) in scope.row.coupon"
                :key="tag.id"
                closable
                style="margin-left:5px"
                @close="delCouponItem(scope.$index,index)">
                {{tag.title}}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </div>
    <div class="box">
      <div class="title">
        添加升级条件
      </div>
      <el-form-item label="升级方式" prop="name">
          <el-radio-group v-model="choose_num">
            <el-radio label="1">满足以下任意条件</el-radio>
            <el-radio label="0">满足以下全部条件</el-radio>
          </el-radio-group>
        </el-form-item>
      <div class=" flexMethods">
        <div v-for="(item, index) in methods1" :key="index" class="mehtodsButton " ref="child" @click="condition(0,index)">
        {{item.title}}
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">升级条件限制</div>
      <el-form-item v-for="(item, index) in choseMethods" :key="index" :label="item.title" prop="name">
        <div style="display:flex" v-if="item.index != '10'">
          <el-input v-model="item.value" :value="item.value" @input="(value, type) => set_now(value, item)" class="demoRuleForm" placeholder="请输入内容"  size="small"></el-input>
          <div class="inputMargin" v-if="item.index=='0'|| item.index=='2' || item.index=='4'|| item.index=='11'">元</div>
          <div class="inputMargin" v-if="item.index=='1'|| item.index=='3' || item.index=='5'">个</div>
          <div class="inputMargin" v-if="item.index=='6'|| item.index=='7'|| item.index=='8'|| item.index=='9'">人</div>
          <div class="inputMargin delColor" @click="condition(1, index, item)">删除</div>
        </div>
        <div class="right" v-else>
          <div v-if="commonPList.length" class="goods_line">
            <div>已选择</div>
            <div class="goods_name">{{ commonPNames }}</div>
            <div>等<span>{{ commonPList.length }}</span>件商品
            </div>
          </div>
          <el-button @click="checkShow" type="text">选择商品</el-button>
        </div>
      </el-form-item>
    </div>
    <!-- 底部提交 -->
    </el-form>
    <div class="bottom">
      <el-button @click="goBack()">取消</el-button>
      <el-button type="primary" @click="save_con">确定</el-button>
    </div>
    <!-- 商品选择弹框 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity :sList="sList" @close="showSelecter = false" @getCommod="getCommod" :jude ="2"></selectCommodity>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { goodsList } from "@/api/vip";
import { edit_level_detail, level_detail } from "@/api/user";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    selectCommodity
  },
  data() {
    return {
      buttonShow: false, //
      isIndeterminate: true,
      qualification: "0",//分销商条件
      imageUrl: '',
      setServel: "0",
      type_arr: ['余额', '积分', '优惠券'],
      now_type: "余额",
      choose_num: "1",
      now_couponIdx: "",
      tableData: [{
        list_str: '',
        name: '一级分销优惠券',
      }, {
        list_str: '',
        name: '二级分销优惠券',
      }, {
        list_str: '',
        name: '三级分销优惠券',
      }],
      levelList: [
        {name: "一级", value: 1},
        {name: "二级", value: 2},
        {name: "三级", value: 3},
        {name: "四级", value: 4},
        {name: "五级", value: 5},
        {name: "六级", value: 6},
        {name: "七级", value: 7},
        {name: "八级", value: 8},
        {name: "九级", value: 9},
        {name: "十级", value: 10},
      ],
      form_obj : {
        level: ['一级','二级','三级','四级','五级','六级','七级','八级','九级','十级'],
        now_level: "",
        oil_tab: [],
        now_oil: "",
        nowText: ""
      },
      ratio: {
        frist: "",
        two: "",
        three: ""
      },
      point: {
        frist: "",
        two: "",
        three: ""
      },
      commission: [],
      now_tabIdx: 0,
      other_obj: {
        level_name: "",
        spread_num: "",
        custom_amount: "",
        recharge_amount: "",
        spread_amount: "",
        total_num: "",
        gas_num: "",
        diesel_num: "",
      },
      methods1:[
        {
          title: "分销消费金额",
          index: "0",
          key: "custom_amount"
        },
        {
          title: "分销充值金额",
          index: "1",
          key: "recharge_amount"
        },
        {
          title: "分销总金额",
          index: "2",
          key: "spread_amount"
        },
        {
          title: "分销加油升数",
          index: "3",
          key: "total_num"
        },
        {
          title: "分销汽油升数",
          index: "4",
          key: "gas_num"
        },
        {
          title: "分销柴油升数",
          index: "5",
          key: "diesel_num"
        }
      ],
      choseMethods:[],
      sList: [], //已选择的商品列表
      showSelecter: false,
      commonPId: "",
      commonPList: [],
      commonPNames: "",
      couponIndex: 0,
    };
  },
  created() {
    this.get_oilList();
  },
  methods: {
    async get_detail() {
      try {
        var data = { app_id: this.app_id, id: this.$route.query.id };
        const res = await level_detail(data);
        if (res.code == 200) {
          this.choose_num = res.data.choose_num.toString();
          this.other_obj = {
            level_name: res.data.level_name,
            spread_num: res.data.spread_num,
            custom_amount: res.data.custom_amount,
            recharge_amount: res.data.recharge_amount,
            spread_amount: res.data.spread_amount,
            total_num: res.data.total_num,
            gas_num: res.data.gas_num,
            diesel_num: res.data.diesel_num,
          }
          this.form_obj.now_level = res.data.level
          res.data.commission.forEach(item => {
            var idx = this.form_obj.oil_tab.findIndex(x => x.id == item.goods_id)
            this.commission[idx * 3].balance = item.frist_balance;
            this.commission[idx * 3].point = item.frist_point;
            this.commission[idx * 3].coupon = Object.assign([],item.frist_coupon);

            this.commission[idx * 3 + 1].balance = item.second_balance;
            this.commission[idx * 3 + 1].point = item.second_point;
            this.commission[idx * 3 + 1].coupon = Object.assign([],item.second_coupon);

            this.commission[idx * 3 + 2].balance = item.third_balance;
            this.commission[idx * 3 + 2].point = item.third_point;
            this.commission[idx * 3 + 2].coupon = Object.assign([],item.third_coupon);
            console.log(this.commission[idx*3])
          })
          // this.commission = res.data.commission;
          if(this.other_obj.custom_amount){
            this.$refs.child[0].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[0])
            i.value = this.other_obj.custom_amount
            this.choseMethods.push(i);
          }
          if(this.other_obj.recharge_amount && this.other_obj.recharge_amount != "0.00"){
            this.$refs.child[1].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[1])
            i.value = this.other_obj.recharge_amount
            this.choseMethods.push(i);
          }
          if(this.other_obj.spread_amount && this.other_obj.spread_amount != "0.00"){
            this.$refs.child[2].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[2])
            i.value = this.other_obj.spread_amount
            this.choseMethods.push(i);
          }
          if(this.other_obj.total_num){
            this.$refs.child[3].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[3])
            i.value = this.other_obj.total_num
            this.choseMethods.push(i);
          }
          if(this.other_obj.gas_num){
            this.$refs.child[4].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[4])
            i.value = this.other_obj.gas_num
            this.choseMethods.push(i);
          }
          if(this.other_obj.diesel_num){
            this.$refs.child[5].style = "color: #409EFF; border: 1px solid #409EFF";
            var i = Object.assign({},this.methods1[5])
            i.value = this.other_obj.diesel_num
            this.choseMethods.push(i);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 设置等级
    set_leval(idx) {
      this.form_obj.now_level = idx + 1;
    },
    set_now(val, item) {
      this.other_obj[item.key] = val;
      // this.commission[item.idx] = val;
      console.log(this.other_obj);
    },
    set_coupons(index) {
      this.now_couponIdx = index;
      this.showSelecter = true;
    },
    async save_con() {
      var clist = [];
      this.commission.forEach((item,index) => {
        if(index % 3 == 0){
          var obj = {}
          obj.goods_id = item.goods_id;
          obj.frist_balance = item.balance;
          obj.frist_point = item.point;
          obj.frist_coupon = item.coupon.map(x => x.id).join(',')
          
          obj.second_balance = this.commission[index+1].balance;
          obj.second_point = this.commission[index+1].point;
          obj.second_coupon = this.commission[index+1].coupon.map(x => x.id).join(',');
          
          obj.third_balance = this.commission[index+2].balance;
          obj.third_point = this.commission[index+2].point;
          obj.third_coupon = this.commission[index+2].coupon.map(x => x.id).join(',');
          clist.push(obj)
        }
      })
      try {
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.id,
          choose_num: this.choose_num,
          level: this.form_obj.now_level,
          ...this.other_obj,
          commission: clist,
        }
        console.log(data)
        // return false;
        const res = await edit_level_detail(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.goBack();
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取油品列表
    async get_oilList() {
      try {
        var data = {
          token: this.token,
          app_id: this.app_id,
          page: 1,
          limit: 10,
          name: "",
          store_id: 0
        };
        const res = await goodsList(data);
        if (res.code == 200) {
          this.form_obj.oil_tab = res.data;
          this.form_obj.oil_tab.push({ name: '充值', id: 0 });
          // this.form_obj.now_oil = res.data[0].name;
          this.form_obj.oil_tab.forEach( item => {
            var obj = {
              goods_id: item.id,
              name: item.name,
              level: "一级分销",
              coupon: [],
              balance: "",
              point: ""
            }
            var obj1 = {
              goods_id: item.id,
              name: item.name,
              coupon: [],
              level: "二级分销",
              balance: "",
              point: ""
            }
            var obj2 = {
              goods_id: item.id,
              name: item.name,
              coupon: [],
              level: "三级分销",
              balance: "",
              point: ""
            }
            this.commission.push(obj)
            this.commission.push(obj1)
            this.commission.push(obj2)
          })
          console.log(this.form_obj.oil_tab)
          console.log(this.commission)
          this.get_detail();
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error)
      }
    },
    checkShow() {
      console.log("wobneidianji");
      this.showSelecter = true;
      this.sList = this.commonPList;
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.oul_typeArr : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 选择优惠券
    getCommodOne(data){
      console.log(data);
      let arr = [];
      let arr_2 = [];
      let key = "";
      switch (this.now_couponIdx) {
        case 0:
          key = "frist_coupon";
          break;
        case 1:
          key = "second_coupon";
          break;        
        case 2:
          key = "third_coupon";
          break;
        default:
          break;
      }
      data.forEach(item => {
        arr.push(item.name);
        arr_2.push(item.id);
      })
      console.log(arr)
      this.tableData[this.now_couponIdx].list_str = arr.join(',');
      this.commission[this.now_tabIdx][key] = arr_2.join(',');
      this.couponOne = data;
      this.showSelecter = false;
      console.log(this.commission)
    },
    condition(type, index, item){
      if(type == 0){
        var jude = this.choseMethods.some(item => {return item.index == index});
        if(jude){
          this.$message("该升级条件已经存在，请勿重复添加！！");
          return false;
        }
        this.$refs.child[index].style = "color: #409EFF; border: 1px solid #409EFF";
        this.choseMethods.push(this.methods1[index]);
      } else {
        var id = this.choseMethods[index].index;
        this.$refs.child[id].style="border: 1px solid #e5e5e5;color: #666;";
        this.choseMethods.splice(index, 1);
        this.other_obj[item.key] = "";
      }
    },
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 选择优惠券
    selectCoupon(coupon,index){
      console.log(coupon,index)
      this.couponIndex = index;
      this.sList = Object.assign([],coupon);
      this.showSelecter = true;
    },
    // 选择优惠券
    getCommod(data){
      data.forEach(item => {
        item.title = item.name;
      })
      this.commission[this.couponIndex].coupon = Object.assign([],data);
      this.showSelecter = false;
    },
    // 删除优惠券
    delCouponItem(index,idx){
      this.commission[index].coupon.splice(idx,1);
      console.log(this.commission[index].coupon)
    },
    goBack(){
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.level-list {
  width: 450rpx;
  display: flex;
  flex-direction: column;
}
.left-lst,.right-lst {
  display: flex;
}
.right-lst {
  margin-left: -50px;
}
.left-lst-item, .right-lst-item {
  margin-right: 10px;
}
.my-oil {
  width: 450px;
  height: auto;
}
</style>


<style lang="scss" scoped>
.content {
  padding: 0 20px 60px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  background: #f2f2f6;
  font-size: 14px;
  overflow: scroll;
  position: relative;
  .chang-type {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .el-input {
      margin-top: 10px;
    }
  }
  .el-col{
    padding: 0;
    // 商品表
    .productcart{
      width: 500px;
      .top {
        padding: 6px;
        background: #f2f2f6;
        display: flex;
        justify-content: space-between;
      }
      .cont{
        display: flex;
        justify-content: space-between;
      }
      div{
        padding: 6px;
        line-height: 16x;
      }
    }
  }
  .box{
    background: #fff;
    margin-top: 20px;
    padding: 10px 0px;
    .title{
      font-weight: 550;
      padding: 10px 0px 10px 20px;
    }
    // 样式
    .textAlign{
      text-align: right;
    }
    .color{
      margin: 10px 0;
      color: #999;
    }
    .inputMargin{
      margin: 0 6px;
      cursor: pointer;
    }
    .delColor{
      color: #F56C6C;
    }
    .mehtodsButton{
      padding: 6px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      color: #666;
      margin: 0px 20px 20px 0px;
    }
    .flexMethods{
      display: flex;
      flex-wrap: wrap;
      margin: 12px 0;
      padding-left: 130px;
      width: 90%;
    }
  }
  // 底部
  .bottom{
    position: fixed;
    bottom : 0;
    border-top : 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
}
.oil_item{
  display: flex;
  margin-bottom: 10px;
  .label{
    width:40px;
    line-height: 30px;
    margin-right: 15px;
    text-align: right;
  }
  .label2{
    width: 80px;
    margin-right: 15px;
    text-align: right;
  }
  .level_line{
    display: flex;
    line-height: 30px;
  }
}
.demoRuleForm{
  width: 360px;
}
</style>